import { mergeAttributes } from '@tiptap/core';
import Link from '@tiptap/extension-link';

export const LinkWithTitle = Link.extend({
  renderHTML({ HTMLAttributes }) {
    const attrs = { ...HTMLAttributes };
    if (attrs.href && !attrs.title) {
      attrs.title = String(attrs.href);
    }
    return ['a', mergeAttributes(this.options.HTMLAttributes, attrs), 0];
  },
});

export default LinkWithTitle;
